import { render } from "./NotFound.vue?vue&type=template&id=7cf78d78"
const script = {}
script.render = render

export default script